import React from "react"
import { useStaticQuery, graphql, Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import { twMerge } from "tailwind-merge"
import { PageButton } from "../el/button"
import { P } from "../el/typography"
import Tic from "../svg/tic/tic"
const HeroSection = () => {
  const data = useStaticQuery(graphql`
    {
      site {
        siteMetadata {
          company {
            company
          }
        }
      }
    }
  `)

  return (
    <div className="content relative z-10 overflow-hidden border-b bg-white">
      <div className="mx-auto max-w-screen-xl ">
        <div className="relative z-10 bg-white pb-8 sm:pb-16 md:pb-20 lg:w-full lg:max-w-2xl">
          <div className="hidden shadow-md rounded-full lg:block w-48 h-48 absolute top-28 -right-36 z-50 hover:scale-95 hover:shadow-amber-400 transition-all duration-90">
            <Link to="/flaskusanything">
              <StaticImage
                alt="FlAsk Us Anything!"
                src="../../images/page/marketing/fua-logo.png"
                placeholder="blurred"
                className="shadow-lg rounded-full"
                imgClassName=""
              />
            </Link>
          </div>
          <svg
            className="absolute z-10 inset-y-0 right-0 hidden h-full w-48 translate-x-1/2 transform text-white lg:block"
            fill="currentColor"
            viewBox="0 0 100 100"
            preserveAspectRatio="none"
          >
            <polygon points="50,0 100,0 50,100 0,100" />
          </svg>

          <main className="mx-auto max-w-screen-xl px-4 pt-10 sm:px-6 sm:pt-12 md:pt-16 lg:px-8 lg:pt-28">
            <div className="text-center lg:text-left">
              <div className="mx-auto rounded-full shadow-sm mb-5 w-28 h-28 lg:hidden hover:scale-95 hover:shadow-amber-400 transition-all duration-90">
                <Link to="/flaskusanything">
                  <StaticImage
                    alt="FlAsk Us Anything!"
                    src="../../images/page/marketing/fua-logo.png"
                    placeholder="blurred"
                    className="rounded-full shadow-md"
                    imgClassName=""
                  />
                </Link>
              </div>
              <Tic className="ticStandard h-24 w-auto mx-auto lg:mx-0" />
              {/* <H1 className="mt-0 sm:mt-0 hidden lg:block">
                Solutions At Work&trade;
              </H1> */}
              <P hero className="sm:mx-auto sm:max-w-xl md:mt-5 lg:mx-0">
                The mission of {data.site.siteMetadata.company.company}{" "}
                Instrument Company is to partner with our customers, provide
                technical expertise and deliver practical scientific
                innovations. <b>Made in the USA</b>.
              </P>
              <div className="mt-5 sm:mt-8 sm:flex sm:justify-center lg:justify-start">
                <PageButton hero dark to="/cellculture">
                  Cell Culture Solutions
                </PageButton>
                <PageButton
                  hero
                  light
                  className="mt-3 sm:ml-3 sm:mt-0"
                  to="/analytical"
                >
                  Analytical Solutions
                </PageButton>
              </div>
            </div>
          </main>
        </div>
      </div>
      <div className="bg-white lg:absolute lg:inset-y-0 lg:right-0 lg:w-1/2 lg:bg-blue-100">
        <Link to="/flaskusanything">
          <StaticImage
            alt={data.site.siteMetadata.company.company}
            src="../../images/page/layout/header/squareshorizontal.png"
            placeholder="blurred"
            layout="fullWidth"
            className={twMerge(["animateHeaderImage", "staticOnLarge"])}
            imgClassName="heroSectionImageStyle"
          />
        </Link>
      </div>
    </div>
  )
}

export default HeroSection
